module.exports = __webpack_public_path__ + "img/plan.3d678f72.png";